import { ReactElement } from 'react';

// Hooks.
import { useInstitutions, useAccount } from 'hooks';

// Layouts.
import { ContentLayout } from 'layouts';

// Components.
import { InstitutionItem } from './InstitutionItem';

import styles from './InstitutionListView.module.scss';
import { Button, ButtonVariants, LoadingOverlay } from '@comptia-sso/core';

export const InstitutionListView = (): ReactElement => {
  const [institutions, { isLoading }] = useInstitutions();
  const [account] = useAccount();

  const displayInstitutions = () => {
    return (
      <>
        <header>
          <h2>Institutions ({institutions?.length})</h2>
        </header>
        <div className={styles.results}>
          {institutions?.map((institution) => (
            <InstitutionItem key={institution.id} institution={institution} />
          ))}
        </div>
      </>
    );
  };

  return (
    <>
      <ContentLayout
        header={
          <div className={styles.header}>
            {!!account?.permissions?.editInstructorApprovers && (
              <Button
                className={styles.add}
                link
                to="/consent-approvers/institutions/add"
                variant={ButtonVariants.Primary}
              >
                Add Institution
              </Button>
            )}
          </div>
        }
        content={institutions && displayInstitutions()}
      />
      <LoadingOverlay isOpen={isLoading} text="Please Wait" />
    </>
  );
};
